import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { MemberResponse } from './types';

export async function deactivateMember(memberId: string) {
  const url = `/web/studio/users/${memberId}/deactivate`;

  const response = await api.executePutRequest<ObjectResponse<MemberResponse>>(url);

  return response.data;
}
